import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Task"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10.5 15.135L7.8075 12.4425L6.75 13.5L10.5 17.25L17.25 10.5L16.1925 9.43498L10.5 15.135ZM18.75 3.75H16.5V3C16.5 2.17157 15.8284 1.5 15 1.5H9C8.17157 1.5 7.5 2.17157 7.5 3V3.75H5.25C4.42157 3.75 3.75 4.42157 3.75 5.25V21C3.75 21.8284 4.42157 22.5 5.25 22.5H18.75C19.5784 22.5 20.25 21.8284 20.25 21V5.25C20.25 4.42157 19.5784 3.75 18.75 3.75ZM9 3H15V6H9V3ZM5.25 21H18.75V5.25H16.5V7.5H7.5V5.25H5.25V21Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Task.vue"]]);
